module.exports = __webpack_public_path__ + "media/images/sessel-c41bff51da710c7b3173dbe47b68cf47.png";